import { useContext, createContext } from 'react';

type AppTitleContextValue = {
  setTitleOverride: (title: string | null) => void;
};

export const AppTitleContext = createContext<AppTitleContextValue | null>(null);

export function useAppTitleOverride() {
  return useContext(AppTitleContext);
}
